import { useInfiniteQuery, useQuery } from 'react-query'

// Libs
import { fetchLiveMallSearchData } from '@/api/fetchLiveMallSearchData'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { LiveMallSearchCategory, LiveMallSearchType } from '@/types/live-mall-search/types'
import { useMemberData } from './useMemberData'

const useLiveMallSearchQuery = ({ keyword, type, enabled = true }: { keyword: string; type: LiveMallSearchCategory; enabled?: boolean }) => {
  const queryKey = [QUERY_KEY.FETCH_LIVE_MALL_SEARCH, keyword, type]

  const {
    data,
    isLoading,
    error,
    refetch: simpleRefetch,
    isFetching,
  } = useQuery<LiveMallSearchType>({
    queryKey,
    queryFn: () => fetchLiveMallSearchData({ keyword, type }),
    enabled,
  })
  const { memberData } = useMemberData()
  const isLogin = !!memberData?.memberInfoId

  const feedDataQuery = useInfiniteQuery<LiveMallSearchType, Error>(
    queryKey,
    ({ pageParam }) =>
      fetchLiveMallSearchData({
        keyword,
        type,
        cursorId: pageParam?.cursorId,
      }),
    {
      getNextPageParam: (lastPage) => {
        if (lastPage.hasMore) {
          return {
            cursorId: lastPage.cursorId,
          }
        } else {
          return null
        }
      },
      enabled: isLogin && enabled,
    },
  )

  const handleNextPage = () => {
    if (feedDataQuery.hasNextPage && feedDataQuery.isFetchingNextPage === false) {
      feedDataQuery.fetchNextPage()
    }
  }

  return {
    data,
    isLoading,
    isFetching,
    error,
    feedDataQuery,
    handleNextPage,
    hasNextPage: feedDataQuery.hasNextPage,
    refetch: feedDataQuery.refetch,
    simpleRefetch,
  }
}

export default useLiveMallSearchQuery
